
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-page",
      function () {
        return require("private-next-pages/home-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-page"])
      });
    }
  